export default "__VITE_ASSET__BybrtM0h__"